import React, { useEffect, useState, useCallback  } from "react";
import {

  TableContainer,
  TableToolbar,
  TableToolbarContent,
  TableToolbarSearch,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCell,
  Button,
  Modal,
  TextInput,
  TableToolbarAction,
  TableToolbarMenu,
  Dropdown,
  InlineLoading,
  
} from "@carbon/react";
import { Add, Edit, TrashCan } from "@carbon/icons-react";
import { callApi } from "../../../services/apiService";

const headers = [
  { key: "AREA_NAME", header: "Area Name" },
  { key: "TALUK_NAME", header: "Taluk" },
  { key: "DISTRICT_NAME", header: "District" },
  { key: "VILLAGE_NAME", header: "Village" },
  { key: "STATE_NAME", header: "State" },
  { key: "COUNTRY_NAME", header: "Country" },
  { key: "STATUS", header: "Status" },
  { key: "actions", header: "Actions" },
];

export default function AreaManagement() {
  const [areas, setAreas] = useState([]);
  const [filteredAreas, setFilteredAreas] = useState([]);
  const [taluks, setTaluks] = useState([]);
  const [villages, setVillages] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
 // const [ setNotification] = useState({ isVisible: false, message: "", kind: "" });

  // Form states
  const [formData, setFormData] = useState({
    AREA_NAME: "",
    TALUK_ID: "",
    VILLAGE_ID: "",
    STATUS: "Active",
  });
  const [selectedArea, setSelectedArea] = useState(null);
  const [areaToDelete, setAreaToDelete] = useState(null);

  // Fetch all data
const fetchAllData = useCallback(async () => {
    setLoading(true);
    try {
      // Fetch areas with complete details
      const areasResponse = await callApi("GET", "/areas/");
      setAreas(areasResponse.data || []);
      setFilteredAreas(areasResponse.data || []);

      // Fetch taluks for dropdown
      const taluksResponse = await callApi("GET", "/taluk-masters/");
      console.log("Taluks API Response:", taluksResponse);
      setTaluks(taluksResponse.data || []);

      // Fetch villages for dropdown
      const villagesResponse = await callApi("GET", "/villages/");
      console.log("Villages API Response:", villagesResponse);
      setVillages(villagesResponse.data || []);

    } catch (error) {
      showNotification("Failed to fetch data: " + error.message, "error");
    } finally {
      setLoading(false);
    }
}, []);

  useEffect(() => {
    fetchAllData();
  }, [fetchAllData]);

  // Show notification
  const showNotification = (message, kind = "info") => {
   // setNotification({ isVisible: true, message, kind });
    setTimeout(() => {
     // setNotification({ isVisible: false, message: "", kind: "" });
    }, 5000);
  };

  // Handle search
  const handleSearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    if (searchTerm) {
      const filtered = areas.filter(area =>
        area?.AREA_NAME?.toLowerCase().includes(searchTerm) ||
        area?.TALUK_NAME?.toLowerCase().includes(searchTerm) ||
        area?.DISTRICT_NAME?.toLowerCase().includes(searchTerm) ||
        area?.VILLAGE_NAME?.toLowerCase().includes(searchTerm) ||
        area?.STATE_NAME?.toLowerCase().includes(searchTerm) ||
        area?.COUNTRY_NAME?.toLowerCase().includes(searchTerm) ||
        area?.STATUS?.toLowerCase().includes(searchTerm)
      );
      setFilteredAreas(filtered);
    } else {
      setFilteredAreas(areas);
    }
  };

  // Open modal for Add/Edit
  const openModal = (area = null) => {
    if (area) {
      setFormData({
        AREA_NAME: area.AREA_NAME || "",
        TALUK_ID: area.TALUK_ID ? area.TALUK_ID.toString() : "",
        VILLAGE_ID: area.VILLAGE_ID ? area.VILLAGE_ID.toString() : "",
        STATUS: area.STATUS || "Active",
      });
      setSelectedArea(area);
    } else {
      setFormData({
        AREA_NAME: "",
        TALUK_ID: "",
        VILLAGE_ID: "",
        STATUS: "Active",
      });
      setSelectedArea(null);
    }
    setIsModalOpen(true);
  };

  // Close modal and reset form
  const closeModal = () => {
    setIsModalOpen(false);
    setFormData({ 
      AREA_NAME: "", 
      TALUK_ID: "", 
      VILLAGE_ID: "", 
      STATUS: "Active" 
    });
    setSelectedArea(null);
  };

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Handle dropdown changes
  const handleDropdownChange = ({ name, value }) => {
    setFormData(prev => ({
      ...prev,
      [name]: value,
      // If taluk is changed, reset village selection
      ...(name === "TALUK_ID" && { VILLAGE_ID: "" })
    }));
  };

  // Get villages filtered by selected taluk
  const getFilteredVillages = () => {
    if (!formData.TALUK_ID) return [];
    return villages.filter(village => 
      village && village.TALUK_ID && village.TALUK_ID.toString() === formData.TALUK_ID
    );
  };

  // Get taluk items for dropdown
  const getTalukItems = () => {
    if (!taluks || !Array.isArray(taluks)) {
      console.log("Taluks is not an array or empty:", taluks);
      return [];
    }
    
    const items = taluks
      .filter(taluk => taluk && taluk.id != null && taluk.name)
      .map(taluk => ({
        id: taluk.id?.toString() || '',
        text: taluk.name || '',
        value: taluk.id?.toString() || '',
        district_id: taluk.district_id
      }));
    
    console.log("Formatted taluk items:", items);
    return items.filter(item => item.id && item.text);
  };

  // Get village items for dropdown - UPDATED WITH VILLAGE API STRUCTURE
  const getVillageItems = () => {
    const filteredVillages = getFilteredVillages();
    if (!filteredVillages || !Array.isArray(filteredVillages)) {
      console.log("Filtered villages is not an array or empty:", filteredVillages);
      return [];
    }
    
    const items = filteredVillages
      .filter(village => village && village.VILLAGE_ID != null && village.VILLAGE_NAME)
      .map(village => ({
        id: village.VILLAGE_ID?.toString() || '',
        text: village.VILLAGE_NAME || '',
        value: village.VILLAGE_ID?.toString() || '',
        TALUK_ID: village.TALUK_ID
      }));
    
    console.log("Formatted village items:", items);
    return items.filter(item => item.id && item.text);
  };

 
  // Find selected item safely
  const findSelectedItem = (items, value) => {
    if (!value || !items || !Array.isArray(items)) return null;
    return items.find(item => item?.value === value.toString()) || null;
  };

  // Save Area (Add / Update)
  const handleSave = async (e) => {
    e.preventDefault();
    
    if (!formData.AREA_NAME.trim()) {
      showNotification("Area name is required", "error");
      return;
    }

    if (!formData.TALUK_ID) {
      showNotification("Please select a taluk", "error");
      return;
    }

    if (!formData.VILLAGE_ID) {
      showNotification("Please select a village", "error");
      return;
    }

    const payload = selectedArea ? {
      // PUT Payload
      AREA_ID: selectedArea.AREA_ID,
      AREA_NAME: formData.AREA_NAME.trim(),
      TALUK_ID: parseInt(formData.TALUK_ID),
      VILLAGE_ID: parseInt(formData.VILLAGE_ID),
      UPDATED_BY_USER_ID: 1 // Replace with actual user ID from auth
    } : {
      // POST Payload
      AREA_NAME: formData.AREA_NAME.trim(),
      TALUK_ID: parseInt(formData.TALUK_ID),
      VILLAGE_ID: parseInt(formData.VILLAGE_ID),
      CREATED_BY_USER_ID: 1, // Replace with actual user ID from auth
      UPDATED_BY_USER_ID: 0
    };

    setLoading(true);
    try {
      if (selectedArea) {
        await callApi("PUT", "/areas/", payload);
        showNotification("Area updated successfully", "success");
      } else {
        await callApi("POST", "/areas/", payload);
        showNotification("Area added successfully", "success");
      }

      await fetchAllData();
      closeModal();
    } catch (error) {
      showNotification("Failed to save area: " + error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  // Confirm delete
  const confirmDelete = (area) => {
    setAreaToDelete(area);
    setIsDeleteModalOpen(true);
  };

  // Handle delete
  const handleDelete = async () => {
    if (!areaToDelete) return;

    setLoading(true);
    try {
      await callApi("DELETE", `/areas/${areaToDelete.AREA_ID}`);
      showNotification("Area deleted successfully", "success");
      await fetchAllData();
    } catch (error) {
      showNotification("Failed to delete area: " + error.message, "error");
    } finally {
      setIsDeleteModalOpen(false);
      setAreaToDelete(null);
      setLoading(false);
    }
  };

  return (
    <div className="area-management">
      {/* Notification */}
      {/* {notification.isVisible && (
        <Notification
          kind={notification.kind}
          title={notification.kind === "error" ? "Error" : "Success"}
          subtitle={notification.message}
          onClose={() => setNotification({ isVisible: false, message: "", kind: "" })}
          lowContrast
          style={{ marginBottom: "1rem" }}
        />
      )} */}

      <TableContainer title="Area Management">
        <TableToolbar>
          <TableToolbarContent>
            <TableToolbarSearch 
              placeholder="Search areas..." 
              onChange={handleSearch}
              persistent
            />
            <Button 
              renderIcon={Add} 
              onClick={() => openModal()}
              disabled={loading}
            >
              Add Area
            </Button>
          </TableToolbarContent>
        </TableToolbar>

        {loading ? (
          <div style={{ padding: "2rem", textAlign: "center" }}>
            <InlineLoading description="Loading areas..." />
          </div>
        ) : (
          <Table>
            <TableHead>
              <TableRow>
                {headers.map((header) => (
                  <TableHeader key={header.key}>{header.header}</TableHeader>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredAreas.length > 0 ? (
                filteredAreas.map((area) => (
                  <TableRow key={area.AREA_ID}>
                    <TableCell>{area.AREA_NAME}</TableCell>
                    <TableCell>{area.TALUK_NAME}</TableCell>
                    <TableCell>{area.DISTRICT_NAME}</TableCell>
                    <TableCell>{area.VILLAGE_NAME}</TableCell>
                    <TableCell>{area.STATE_NAME}</TableCell>
                    <TableCell>{area.COUNTRY_NAME}</TableCell>
                    <TableCell>
                      
                       
                        {area.STATUS}
                      
                    </TableCell>
                    <TableCell>
                      <TableToolbarMenu>
                        <TableToolbarAction 
                          renderIcon={Edit}
                          onClick={() => openModal(area)}
                          disabled={loading}
                        >
                          Edit
                        </TableToolbarAction>
                        <TableToolbarAction 
                          renderIcon={TrashCan}
                          onClick={() => confirmDelete(area)}
                          disabled={loading}
                        >
                          Delete
                        </TableToolbarAction>
                      </TableToolbarMenu>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={8} style={{ textAlign: "center" }}>
                    No areas found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        )}
      </TableContainer>

      {/* Add/Edit Modal */}
      <Modal
        open={isModalOpen}
        onRequestClose={closeModal}
        modalHeading={selectedArea ? "Edit Area" : "Add New Area"}
        primaryButtonText={loading ? <InlineLoading /> : "Save"}
        secondaryButtonText="Cancel"
        onRequestSubmit={handleSave}
        primaryButtonDisabled={loading || !formData.AREA_NAME.trim() || !formData.TALUK_ID || !formData.VILLAGE_ID}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
          <TextInput
            id="AREA_NAME"
            name="AREA_NAME"
            labelText="Area Name"
            value={formData.AREA_NAME}
            onChange={handleInputChange}
            placeholder="Enter area name"
            required
            invalid={!formData.AREA_NAME.trim()}
            invalidText="Area name is required"
          />
          
          <Dropdown
            id="TALUK_ID"
            name="TALUK_ID"
            titleText="Taluk"
            label="Select Taluk"
            items={getTalukItems()}
            itemToString={(item) => item ? item.text : ''}
            selectedItem={findSelectedItem(getTalukItems(), formData.TALUK_ID)}
            onChange={(e) => {
              if (e.selectedItem) {
                console.log("Selected Taluk:", e.selectedItem);
                handleDropdownChange({
                  name: "TALUK_ID",
                  value: e.selectedItem.value
                });
              }
            }}
            required
          />

          <Dropdown
            id="VILLAGE_ID"
            name="VILLAGE_ID"
            titleText="Village"
            label={formData.TALUK_ID ? "Select Village" : "First select a taluk"}
            items={getVillageItems()}
            itemToString={(item) => item ? item.text : ''}
            selectedItem={findSelectedItem(getVillageItems(), formData.VILLAGE_ID)}
            onChange={(e) => {
              if (e.selectedItem) {
                console.log("Selected Village:", e.selectedItem);
                handleDropdownChange({
                  name: "VILLAGE_ID",
                  value: e.selectedItem.value
                });
              }
            }}
            disabled={!formData.TALUK_ID}
            required
          />

         
        </div>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal
        open={isDeleteModalOpen}
        modalHeading="Confirm Delete"
        primaryButtonText={loading ? <InlineLoading /> : "Delete"}
        secondaryButtonText="Cancel"
        danger
        onRequestClose={() => setIsDeleteModalOpen(false)}
        onRequestSubmit={handleDelete}
        primaryButtonDisabled={loading}
      >
        <p>
          Are you sure you want to delete the area{" "}
          <strong>"{areaToDelete?.AREA_NAME}"</strong>? This action cannot be undone.
        </p>
      </Modal>
    </div>
  );
}
